export default ['source', 'entityType', 'action', 'gatewayType', 'merchantName'];
